import axios from "axios";
import { useQuery } from "react-query";
import { IDOM_API_URL, PRODUCT_SLUG } from "../config";
import logo from "../assets/newlogo.webp";

export const DEFAULT_BRAND_INFO = {
  app_logo_url: logo,
  fav_icon_url: `${process.env.PUBLIC_URL || ""}/favicon.jpg`,
  app_name: "iDoM",
  product_name: "Notes",
  product_version: "",
  product_description: "Capture ideas, organize notes and checklists, and stay productive with iDoM Notes.",
};

export const normalizeBrandInfo = (data) =>
  Object.fromEntries(Object.entries(DEFAULT_BRAND_INFO).map(([key, fallback]) => [
    key,
    typeof data?.[key] === "string" && data[key].trim() ? data[key].trim() : fallback,
  ]));

export const fetchBrandInfo = async ({ signal, productSlug = PRODUCT_SLUG } = {}) => {
  const fetchFrom = async (baseURL) => {
    const response = await axios.get(
      `${baseURL.replace(/\/+$/, "")}/get-app-and-product-version`,
      {
        params: { product_slug: productSlug },
        headers: { "Cache-Control": "no-store", Pragma: "no-cache", Expires: "0" },
        timeout: 5000,
        signal,
      }
    );
    return normalizeBrandInfo(response.data);
  };

  try {
    return await fetchFrom(IDOM_API_URL);
  } catch (error) {
    if (signal?.aborted || axios.isCancel(error)) throw error;
    if (new URL(IDOM_API_URL).origin !== "https://api.idom.in") {
      return fetchFrom("https://api.idom.in/");
    }
    throw error;
  }
};

export const useAppBrandInfo = () => {
  const query = useQuery(
    ["app-and-product-version", PRODUCT_SLUG],
    ({ signal }) => fetchBrandInfo({ signal }),
    {
      staleTime: 60 * 60 * 1000,
      cacheTime: 24 * 60 * 60 * 1000,
      retry: 1,
      placeholderData: DEFAULT_BRAND_INFO,
      refetchOnWindowFocus: false,
    }
  );
  return { ...query, brandInfo: query.data || DEFAULT_BRAND_INFO };
};
